module.exports = __webpack_public_path__ + "static/geography-f5944a79a3db69481ba7f22fd23095f4.svg";